<template>
    <div class="apprentice-simple-card internships-widget">
        <div class="component-title">
            <h5 class="title">Stages</h5>
            <div class="actions">
                <b-button
                    class="btn-add btn-add-internship"
                    v-if="!teacherAccess"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('internship.add_internships')"
                    @click="showInternshipSignup">
                </b-button>
            </div>
        </div>

        <ul
            class="list-unstyled internship-list"
            v-if="internships.length">
            <li
                class="internship"
                v-for="internship in internships"
                :key="internship.id">
                {{ internship.name }}
            </li>
        </ul>

        <div
            class="not-found with-header empty-internship-list"
            v-else>
            <div
                class="btn-add-circle icon"
                v-b-tooltip.hover
                v-if="!teacherAccess"
                title="Stage kiezen"
                @click="showInternshipSignup"></div>
            <div class="alert-notice">{{ $t('internship.you_are_not_registered_for_an_internship_yet') }}</div>
        </div>

        <div class="show-more">
            <b-button
                class="btn-show-all btn-show-more-internships"
                v-if="internships.length"
                variant="primary"
                @click="showInternships">
                {{ $t('common.more') }}
            </b-button>
        </div>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-internship-widget-component',
    props: {
        internshipsIn: Array,
        teacherAccess: Number,
        userCredentialsIn: Object,
    },
    data() {
        return {
            internships: this.internshipsIn,
        };
    },
    methods: {
        showInternships() {
            window.location.href = this.routes.studentInternshipIndex(this.userCredentialsIn.id);
        },

        showInternshipSignup() {
            window.location.href = this.routes.studentInternshipSignup();
        },
    },
};
</script>

<style scoped lang="scss">
.internships-widget {
    .actions {
        display: flex;
        flex-direction: row;
        align-items: flex-end;

        .btn-add-internship {
            margin-right: map-get($grid-padding-spacing, 'fifteen');
        }

        button {
            &:before {
                margin-right: 0;
            }
        }
    }
}

.internship {
    padding-bottom: map-get($grid-gutter-spacing, 'ten');
    margin-top: map-get($grid-gutter-spacing, 'ten');
    border-bottom: 1px solid $border-color;
    font-weight: $font-weight-medium;
}

.show-more {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .btn-show-more-internships {
        font-weight: $font-weight-bold;
    }
}
</style>
